import {types, getParent, onAction} from "mobx-state-tree"
import {toJS} from "mobx"
import {translate, intl} from 'i18n/localize'

/*
  + DataNav has Paginate & Filter.
  + It will be available as store.data_nav

  filters holds a Map
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map
      filter.size
      filter.entries
      filters.get(key).value
 */
import Paginate from 'model/util/paginate'
import Filter from 'model/util/filter'

const DataNav = types.model({
    filters: types.map(Filter), //types.optional(Filter, Filter.create({})),
    filter_dirty: false,
    show_filters: false, //filter_container_visible
    paginate: types.optional(Paginate, () => Paginate.create({})),

    resetting: types.optional(types.boolean, false)
}).actions(self => ({
        //Go to page (default) can pass extra params
        submit(page = 1, extra = {}) {
            self.go_to_page(page, extra)
            self.show_filters = false
        },

        //Reload current w/o clearing the params
        reload() {
            self.go_to_page(self.paginate.current_page)
        },

        //With Filters and Navigation
        go_to_page(p, extra = {}) {
            getParent(self).set_loading(true)
            getParent(self).get(Object.assign(self.collect_filters().data, {p: p}, extra))
        },
        /*
          Filters: For now we will use volatile values
        */
        seed_filter(filter_id, seed, label) {
            const _filter = Filter.create({id: filter_id})
            _filter.setValue(seed)
            _filter.setDefaultValue(seed)
            _filter.setLabel(label)
            self.filters.set(filter_id, _filter)
            return self.filters.get(filter_id) //Required
        },
        //resetting from default value
        reset_filter(filter_id) {
            self.filters.get(filter_id).reset_value()
        },
        update_filter(filter_id, value){
            self.filters.get(filter_id).setValue(value)
        },
        // Command. Possibly base filters v2 on something along these lines ??
        // For now this is for single actions that don't need to get persisted
        // ex.   store.data_nav.command({flag:true, days:3})
        command(args) {
            self.submit(1, args)
        },
        //
        // return {data:{}, info:'}
        collect_filters() {
            const res = {}
            let filter_info = ''
            self.filters.forEach((fltr) => {
                let param_key = fltr.id
                //Single values will have an object with one key with the same value as fltr.id
                let param_value = Object.keys(fltr.value).includes(fltr.id) ? toJS(fltr.value)[fltr.id] : toJS(fltr.value)
                //ex Array of Tags

                if (Array.isArray(param_value)) {
                    let _value = []
                    let _label = []
                    //info
                    if (param_value.length > 1) filter_info = filter_info + ' ' + fltr.label + ': '
                    param_value.map((v) => {
                        //convention to get the (convention) id
                        if (v instanceof Object) {
                            if (v.hasOwnProperty('id')) {
                                _value.push(v.id)           //Array of objects with ID
                                _label.push(v.name + ' ')
                            } else {
                                // placeholder for now
                            }
                        } else {
                            _value.push(v)
                        }
                    })

                    param_key = `${param_key}[]`//To help submit the values rails way
                    res[param_key] = _value
                    filter_info = filter_info + _label.join(',')
                    //Single assignment object (ex. Property) or multiple (ex Date Range, multiple values, ...)
                } else { //Object
                    if (typeof param_value === "object") {
                        let param_value_keys = Object.keys(param_value)
                        //Convention {:id, :name} means to read only :id  as value
                        if (param_value_keys.includes('id')) {
                            filter_info = filter_info + ' ' + fltr.label + ': ' + param_value.name
                            res[param_key] = param_value.id
                        } else {
                            param_value_keys.map((key) => {
                                if (param_value[key] instanceof Date) {
                                    res[key] = intl.get('DATE_short',  {value: param_value[key]} )
                                } else {
                                    res[key] = param_value[key]
                                }
                                if (res[key]  !== '' ) {
                                  filter_info = filter_info + ' ' + translate(key) + ': ' + res[key]
                                }
                            })
                        }
                    } else {
                        //info
                        filter_info = filter_info + fltr.label + ': ' + param_value + ' '
                        res[param_key] = param_value
                    }
                }
            })
            return {data: res, info: filter_info}
        },

        //Called from filter_commands.jsx ButtonResetFilters
        reset_filters() {
            self.setResetting(true)
            //Reset each listed filter
            self.filters.forEach((fltr) => {
                fltr.reset_value()
            })
            getParent(self).set_loading(true)
            self.filter_dirty = false
            getParent(self).get()
            //not needed code removed
        },

        /*
          Loading
        */
        start_loading() {
            getParent(self).set_loading(true)
        },
        end_loading() {
            getParent(self).set_loading(false)
        },
        isLoading() {
            getParent(self).loading
        },
        setFilterDirty(flag) {
            self.filter_dirty = flag
        },
        setResetting(flag) {
            self.resetting = flag
        },
        showFilters(flag) {
            self.show_filters = flag
        }
    })
)

export default DataNav